/**
 * Fired on `window` when the server refused a write with 403 `subscription_required`: the cached billing status is
 * out of date, so the banner refetches it at once. A DOM event keeps the HTTP client free of any query client.
 */
export const BILLING_STATUS_STALE_EVENT = 'billing:status-stale';

/**
 * Fired on `window` with the refusal (`{ reason, message }`) each time a write is refused with 403
 * `subscription_required`. One listener (ReadOnlyRefusalToast) tells the user why, so no screen can fail silently.
 */
export const READ_ONLY_REFUSED_EVENT = 'billing:write-refused';

export interface ReadOnlyRefusal {
  /** `trial_ended`, `payment_lapsed` or `cancelled`. */
  reason?: string;
  /** The server's sentence (English), used when the reason is unknown. */
  message?: string;
}
